import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ILoginEvent } from "src/app/epicare-public/login/domain/interfaces/login.interface";
import { Subject } from "rxjs";
import { IOrganizationAccess } from "../interfaces/access.interface";

@Injectable({
  providedIn: "root",
})
export class ConnectionEventsService {
  /** Emits after a successful login (or organization switch) with the new authentication data. */
  private loginSubject = new Subject<ILoginEvent>();
  /** Emits when the user logs out. */
  private logoutSubject = new Subject<void>();

  login$ = this.loginSubject.asObservable();
  logout$ = this.logoutSubject.asObservable();

  constructor(private router: Router) {}

  /**
   * Broadcasts a successful login.
   *
   * Triggers application-wide login side effects such as updating the session.
   *
   * @param access Newly issued access and refresh tokens, the organization the session is now
   * scoped to, the functionalities and routes the user's role grants in it, and the user's language.
   */
  notifyLogin(access: IOrganizationAccess): void {
    this.loginSubject.next({
      ...access.tokens,
      organizationId: access.organizationId,
      functionalities: access.functionalities,
      routes: access.routes,
      language: access.language,
    });
  }

  /**
   * Broadcasts a logout event and redirects to the login page.
   *
   * Triggers application-wide logout side effects such as clearing the session
   * and cancelling any pending token verification flow.
   *
   * @param title Optional translation key displayed on the login page.
   */
  notifyLogout(title?: string): void {
    this.logoutSubject.next();
    if (title) {
      this.router.navigate(["login"], { state: { title: title } });
    } else {
      this.router.navigate(["login"]);
    }
  }
}
